import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../assets/css/contactos.css";
import enviar from "../assets/svg/Enviar.svg";
import whatsApp from "../assets/icons/Whatsapp.svg";
import flechaDoble from "../assets/svg/FlechaDoble.svg";
import { PuffLoader } from "react-spinners";

const Contacto = () => {
  const [form, setForm] = useState({
    nombres: "",
    apellidos: "",
    correoElectronico: "",
    numeroTelefono: "",
    consulta: "",
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false); 
  const [showModal, setShowModal] = useState(false); 

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setShowModal(true); 

    emailjs
      .send("service_0yqdsmk", "template_vflg0vo", form, "FiOrOg8ZmLDpRXaoR")
      .then(() => {
        setLoading(false);
        setSubmitted(true); 
        setForm({
          nombres: "",
          apellidos: "",
          correoElectronico: "",
          numeroTelefono: "",
          consulta: "",
        });

        setTimeout(() => {
          setSubmitted(false);
          setShowModal(false); 
        }, 4000);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        
      });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <section className="contacto">
      <div className="title">
        <h1>¿Listo para dar el siguiente paso?</h1>
        <p>
          Nuestro equipo está aquí para ayudarte a alcanzar tus objetivos
          legales. Contáctanos y descubre cómo podemos trabajar juntos.
        </p>
      </div>
      <div className="contenedor-cartas">
        <div className="card-contactos">
          <div className="consultas">
            <div className="tituloConsultas">
              <h1>¿Tienes Alguna Consulta?</h1>
              <h1>¡Estamos Aquí Para Ayudarte!</h1>
            </div>
            <div className="informacion">
              <h3>
                Déjanos tus datos y uno de nuestros especialistas se pondrá en
                contacto contigo lo antes posible o puedes escribirnos a nuestro
                <span className="text-color"> WhatsApp</span>.
              </h3>
            </div>
            <div className="boton-escribenos">
              <a
                href="https://wa.me/51988070758"
                target="_blank"
                rel="noopener noreferrer">
                <button>
                  <img
                    className="whatsApp"
                    src={whatsApp}
                    alt="Icono de WhatsApp"
                  />
                  ¡Escríbenos!
                </button>
              </a>
              <img
                className="flechaDoble"
                src={flechaDoble}
                alt="Flecha señalando a botón"
              />
            </div>
          </div>
          <form className="card-cliente" onSubmit={handleSubmit}>
            <div className="info-Nombres">
              <div className="nombres">
                <h2>Nombres</h2>
                <input
                  type="text"
                  name="nombres"
                  placeholder="Ingrese Nombres"
                  value={form.nombres}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="apellidos">
                <h2>Apellidos</h2>
                <input
                  type="text"
                  name="apellidos"
                  placeholder="Ingrese Apellidos"
                  value={form.apellidos}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="info-Correos">
              <h2>Correo Electrónico</h2>
              <input
                type="email"
                name="correoElectronico"
                placeholder="Ingrese correo electrónico"
                value={form.correoElectronico}
                onChange={handleChange}
                required
              />
            </div>
            <div className="info-Telefono">
              <h2>Número de Teléfono</h2>
              <input
                type="text" 
                name="numeroTelefono"
                placeholder="Ingrese su número telefónico"
                value={form.numeroTelefono}
                onChange={(e) => {
                  
                  const value = e.target.value.replace(/\D/g, "").slice(0, 9);
                  handleChange({ target: { name: "numeroTelefono", value } });
                }}
                maxLength="9"
                required
                style={{
                  appearance: "none",
                  MozAppearance: "textfield", 
                }}
              />
            </div>
            <div className="info-Consulta">
              <h2>Motivo de su consulta</h2>
              <textarea
                name="consulta"
                placeholder="Escriba el motivo por el cual nos está contactando"
                rows="5"
                cols="30"
                value={form.consulta}
                onChange={handleChange}
                required
              />
            </div>
            <div className="info-button">
              <div className="enviarConsulta">
                <button type="submit">
                  Enviar Consulta <img src={enviar} alt="botón de enviar" />
                </button>
              </div>
              <p>
                Te responderemos en menos de 24 horas. Gracias por confiar en
                Torres & Torres.
              </p>
            </div>
          </form>
        </div>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button
              className={`close-button ${!loading && submitted ? "show" : ""}`}
              onClick={handleCloseModal}>
              ×
            </button>
            {loading ? (
              <div className="loading-spinner">
                <PuffLoader color="#E0BA56" size={80} />
              </div>
            ) : submitted ? (
              <div className="mensaje-exito">
                <h2>
                  ¡Gracias por contactarnos! Hemos recibido tu mensaje y te
                  responderemos a la brevedad.
                </h2>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </section>
  );
};

export default Contacto;
